// Game configuration settings for Hangman
export const GAME_CONFIG = {
  MAX_GUESSES: 6,
  MAX_WORD_LENGTH: 15,
  MIN_WORD_LENGTH: 3,
  GAME_TITLE: 'Hangman',
  GAME_SUBTITLE: 'Can you guess the word from my resume?',
  WIN_MESSAGE: 'Well done! You saved the stick figure. 🎉',
  LOSE_MESSAGE: 'Game Over! The word was: ',
  PLAY_AGAIN_TEXT: 'Play Again',
  NEW_GAME_TEXT: 'New Game',
};
